import { CheckCircleOutlined, CloudDownloadOutlined, EditOutlined, ExclamationCircleOutlined, FileExcelOutlined, ImportOutlined, StopOutlined, UsergroupAddOutlined } from "@ant-design/icons";
import { Modal, PageHeader, Popconfirm, Tag, Tooltip, message } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import { ButtonItem, HeaderActions, SegmentedItem, TableItemDinamico } from "../../../Components/Items";
import moment from "moment";
import "moment/locale/es";
import EditarAsignacionReloj from "./EditarAsignacionReloj/EditarAsignacionReloj";
import AgregarAsignacionReloj from "./AgregarAsignacionReloj/AgregarAsignacionReloj";
import AgregarAsignacionesMasivas from "./AgregarAsignacionesMasivas/AgregarAsignacionesMasivas";
import { exportarAsignacionesRelojes } from "./exportarAsignacionesRelojes";
import IconArrowsShuffle from "../../../Icons/IconArrowsShuffle";

moment.locale("es");

class AsignacionRelojes extends Component {
    tableRef = null;
    state = {
        todasAsignaciones: [],
        loading: false,
        valor: 1,
        modalAgregarAsignacionReloj: false,
        modalAgregarAsignacionesMasivas: false,
        modalEditarAsignacionReloj: false,
        modalEditarAsignacionRelojId: null,
        exportando: false,
    };
    // Los últimos filtros y orden con los que se consultó la tabla: el Excel baja
    // lo mismo que se está viendo, pero sin paginar.
    ultimosParams = {};
    consultarAsignacionesRelojes(params) {
        this.ultimosParams = params || {};
        this.setState({ loading: true });
        axios
            .post(
                "asignacionesRelojes/selectTodasAsignacionesRelojes",
                { empresaId: this.props.empresaId, ...params },
                {
                    headers: this.props.headersToken,
                }
            )
            .then((res) => {
                this.setState({ loading: false });
                if (res.data.success !== 2) {
                    this.setState({ todasAsignaciones: [] });
                } else {
                    this.setState({
                        todasAsignaciones: res.data.data,
                        totalRecords: res.data.totalRecords || 0,
                    });
                }
            });
    }

    deshabilitarAsignacion(value) {
        this.setState({ loading: true });
        axios
            .post(
                "asignacionesRelojes/deshabilitarAsignacionReloj",
                { asignacionRelojId: value, empresaId: this.props.empresaId },
                { headers: this.props.headersToken }
            )
            .then((res) => {
                if (res.data.success === 2) {
                    message.success("Asignación deshabilitada");
                } else {
                    message.error(res.data.message || "Sucedio un error y no se pudo deshabilitar");
                }
                if (this.tableRef) {
                    this.tableRef.updateExternalFilters({ valor: this.state.valor });
                }
            });
    }
    habilitarAsignacion(value) {
        this.setState({ loading: true });
        axios
            .post(
                "asignacionesRelojes/habilitarAsignacionReloj",
                { asignacionRelojId: value, empresaId: this.props.empresaId },
                { headers: this.props.headersToken }
            )
            .then((res) => {
                if (res.data.success === 2) {
                    message.success("Asignación habilitada");
                } else {
                    message.error(res.data.message || "Sucedio un error y no se pudo habilitar");
                }
                if (this.tableRef) {
                    this.tableRef.updateExternalFilters({ valor: this.state.valor });
                }
            });
    }

    agregarAsignacionReloj() {
        this.setState({ modalAgregarAsignacionReloj: true });
    }
    cerrarAgregarAsignacionReloj() {
        this.setState({ modalAgregarAsignacionReloj: false });
        this.tableRef.updateExternalFilters({ valor: this.state.valor });
    }
    cerrarAgregarAsignacionesMasivas() {
        this.setState({ modalAgregarAsignacionesMasivas: false });
        this.tableRef.updateExternalFilters({ valor: this.state.valor });
    }
    exportarExcel() {
        const params = { ...this.ultimosParams, valor: this.state.valor };
        this.setState({ exportando: true });
        axios
            .post(
                "asignacionesRelojes/exportarAsignacionesRelojes",
                { ...params, empresaId: this.props.empresaId },
                { headers: this.props.headersToken }
            )
            .then((res) => {
                this.setState({ exportando: false });
                if (res.data.success !== 2) {
                    message.error(res.data.message || "No se pudo exportar a Excel");
                    return;
                }
                if (!res.data.data?.length) {
                    message.info("No hay asignaciones para exportar con estos filtros");
                    return;
                }
                exportarAsignacionesRelojes({
                    asignaciones: res.data.data,
                    empresaNombre: this.props.empresaNombre,
                    valor: params.valor,
                    filters: params.filters,
                });
                if (res.data.truncado) {
                    message.warning(`El Excel trae sólo los primeros ${res.data.data.length} registros; usa los filtros para acotar`);
                }
            })
            .catch(() => {
                this.setState({ exportando: false });
                message.error("Error de conexión al exportar a Excel");
            });
    }
    editarAsignacionReloj(id) {
        this.setState({ modalEditarAsignacionReloj: true, modalEditarAsignacionRelojId: id });
    }
    cerrarEditarAsignacionReloj() {
        this.setState({ modalEditarAsignacionReloj: false });
        this.tableRef.updateExternalFilters({ valor: this.state.valor });
    }

    sincronizarInfromacionAsigancion(id) {
        this.setState({ loading: true });
        axios
            .post(
                "asignacionesRelojes/sincronizarInformacionAsignacionReloj",
                { asignacionRelojId: id, empresaId: this.props.empresaId },
                { headers: this.props.headersToken }
            )
            .then((res) => {
                this.setState({ loading: false });
                if (res.data.success === 2) {
                    message.success("Se ha sincronizado la información de la asignación de reloj");
                } else if (res.data.success === 1) {
                    message.error(res.data.message || "No se puede sincronizar la información de la asignación de reloj");
                } else {
                    message.error(res.data.message || "Hubo un error y la asignación de reloj no se sincronizó");
                }
            });
    }

    consultarInformacionAsignacion(id) {
        this.setState({ loading: true });
        axios
            .post(
                "asignacionesRelojes/consultarInformacionAsignacionReloj",
                { asignacionRelojId: id, empresaId: this.props.empresaId },
                { headers: this.props.headersToken }
            )
            .then((res) => {
                this.setState({ loading: false });
                if (res.data.success === 2) {
                    message.success("Se solicitó al reloj la información guardada de este empleado");
                } else if (res.data.success === 1) {
                    message.error(res.data.message || "No se puede consultar la información de este reloj");
                } else {
                    message.error(res.data.message || "Hubo un error y no se pudo consultar la información");
                }
            });
    }

    render() {
        const columns = [
            {
                title: "Número",
                dataIndex: "numero",
                key: "numero",
                buscar: "serieNumero",
                render: (value, record) => `${record.serie} - ${record.numero}`,
                width: "6%",
            },
            {
                title: "Número Empleado",
                dataIndex: "empleadoSerieNumero",
                key: "empleadoSerieNumero",
                width: "6%",
            },
            {
                title: "Empleado",
                dataIndex: "empleadoNombre",
                key: "empleadoNombre",
                buscar: "empleadoNombre",
                width: "18%",
            },
            {
                title: "Reloj Checador",
                dataIndex: "relojChecadorNombre",
                key: "relojChecadorNombre",
                buscar: "relojChecadorNombre",
                width: "18%",
            },
            {
                title: "Usuario Reloj",
                dataIndex: "usuarioRelojChecador",
                key: "usuarioRelojChecador",
                buscar: "usuarioRelojChecador",
                width: "18%",
            },
            {
                title: "Estado",
                dataIndex: "estado",
                key: "estado",
                width: "8%",
                render: (value) => {
                    if (value === 0) return <Tag color="red">Cancelado</Tag>;
                    if (value === 1) return <Tag color="green">Activo</Tag>;
                    if (value === 2) return <Tag color="orange">Deshabilitado</Tag>;
                    return "—";
                },
            },
            {
                title: "Acción",
                dataIndex: "accion",
                key: "accion",
                width: "10%",
                render: (value, record) => {
                    let buttons = [];

                    if (this.props.permisoEditarAsignacionReloj) {
                        buttons.push(
                            <Tooltip
                                title="Editar Asignación de Reloj"
                                placement="top"
                                overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}
                            >
                                <ButtonItem
                                    key={`editar-${record._id}`}
                                    type="default"
                                    size="small"
                                    cyan
                                    icon={<EditOutlined />}
                                    onClick={() => this.editarAsignacionReloj(record._id)}
                                >
                                </ButtonItem>
                            </Tooltip>
                        );
                    }

                    if (this.props.permisoDeshabilitarAsignacionReloj) {
                        if (record.estado === 1) {
                            buttons.push(
                                <Tooltip
                                    key={`deshabilitar-${record._id}`}
                                    title="Deshabilitar"
                                    placement="top"
                                    overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}
                                >
                                    <ButtonItem
                                        type="default"
                                        size="small"
                                        lima
                                        icon={<CheckCircleOutlined />}
                                        onClick={() => Modal.confirm({
                                            title: 'Deshabilitar Asignación de Reloj',
                                            icon: <ExclamationCircleOutlined />,
                                            content: 'Al deshabilitar esta asignación también se borrarán los datos del empleado en el reloj checador. ¿Deseas continuar?',
                                            okText: 'Sí, deshabilitar',
                                            okType: 'danger',
                                            cancelText: 'Cancelar',
                                            onOk: () => this.deshabilitarAsignacion(record._id),
                                        })}
                                    >
                                    </ButtonItem>
                                </Tooltip>
                            );
                            buttons.push(
                                <Tooltip
                                    title="Sincronizar Informacion Reloj Checador"
                                    placement="top"
                                    overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}
                                >
                                    <ButtonItem
                                        key={`sincronizar-${record._id}`}
                                        type="default"
                                        size="small"
                                        rosa
                                        icon={<span style={{ fontSize: '16px', display: 'flex', alignItems: 'center' }}><IconArrowsShuffle size={16} stroke={2.5} /></span>}
                                        onClick={() => this.sincronizarInfromacionAsigancion(record._id)}
                                    >
                                    </ButtonItem>
                                </Tooltip>
                            );
                            buttons.push(
                                <Tooltip
                                    title="Consultar Datos Guardados en el Reloj"
                                    placement="top"
                                    overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}
                                >
                                    <ButtonItem
                                        key={`consultar-${record._id}`}
                                        type="default"
                                        size="small"
                                        icon={<CloudDownloadOutlined />}
                                        onClick={() => this.consultarInformacionAsignacion(record._id)}
                                    >
                                    </ButtonItem>
                                </Tooltip>
                            );
                        } else {
                            buttons.push(
                                <Popconfirm
                                    key={`habilitar-${record._id}`}
                                    title="¿Seguro que quieres habilitar esta asignación de reloj?"
                                    onConfirm={() => this.habilitarAsignacion(record._id)}
                                    okText="Sí"
                                    cancelText="No"
                                >
                                    <Tooltip
                                        title="Habilitar"
                                        placement="top"
                                        overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}
                                    >
                                        <ButtonItem
                                            type="default"
                                            size="small"
                                            rojo
                                            icon={<StopOutlined />}
                                        >
                                        </ButtonItem>
                                    </Tooltip>
                                </Popconfirm>
                            );
                        }
                    }

                    return <div className="acciones-container">{buttons}</div>;
                }
            },
        ];


        return (
            <>
                <PageHeader
                    title="Asignación de Relojes Checadores"
                    style={{
                        border: "1px solid rgb(235, 237, 240)",
                        backgroundColor: "white",
                        marginBottom: 10,
                    }}
                    extra={
                        <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                            {window.innerWidth > 1000 &&
                                <SegmentedItem
                                    options={[{ label: 'Vigente', value: 1 }, { label: 'Deshabilitada', value: 2 }, { label: 'Todos', value: 3 }]}
                                    onChange={(value) => {
                                        if (this.tableRef) {
                                            this.tableRef.updateExternalFilters({ valor: value, textoFiltro: this.state.textoFiltro });
                                        }
                                        this.setState({ valor: value });
                                    }}
                                    value={this.state.valor}
                                />
                            }
                            {/* Todo lo de aquí adentro va en el menú de los tres puntitos, como en Insumos */}
                            <HeaderActions>
                                {this.props.permisoAgregarAsignacionReloj && (
                                    <ButtonItem
                                        type="default"
                                        key="agregarAsignacionesMasivas"
                                        icon={<UsergroupAddOutlined />}
                                        verde
                                        onClick={() => this.setState({ modalAgregarAsignacionesMasivas: true })}
                                    >
                                        Agregar Varias
                                    </ButtonItem>
                                )}
                                {this.props.permisoAgregarAsignacionReloj && (
                                    <ButtonItem
                                        type="default"
                                        key="importarAsignacionRelojes"
                                        icon={<ImportOutlined />}
                                        onClick={() => this.props.history.push("/panel/importarAsignacionRelojes")}
                                    >
                                        Importar / Descargar Excel
                                    </ButtonItem>
                                )}
                                <ButtonItem
                                    type="default"
                                    key="exportarAsignacionRelojes"
                                    icon={<FileExcelOutlined />}
                                    azulMarino
                                    loading={this.state.exportando}
                                    onClick={this.exportarExcel.bind(this)}
                                >
                                    Exportar a Excel
                                </ButtonItem>
                            </HeaderActions>
                            {this.props.permisoAgregarAsignacionReloj && (
                                <ButtonItem
                                    type="primary"
                                    key="agregarAsignacionReloj"
                                    onClick={this.agregarAsignacionReloj.bind(this)}
                                >
                                    Agregar Asignación de Reloj
                                </ButtonItem>
                            )}
                        </div>
                    }
                />
                <TableItemDinamico
                    ref={(ref) => this.tableRef = ref}
                    onRef={(ref) => this.tableRef = ref}
                    totalRecords={this.state.totalRecords}
                    loading={this.state.loading}
                    onFetchData={this.consultarAsignacionesRelojes.bind(this)}
                    anadirValorFiltro={this.state.valor}
                    size="small"
                    onlyMineFilter
                    dataSource={this.state.todasAsignaciones}
                    columns={columns}
                    scroll={{ x: "max-content" }}
                    filterStorageKey={"asignacionesRelojes" + this.props.empresaId}
                    onRow={(record) => ({
                        onDoubleClick: () => {
                            if (this.props.permisoEditarAsignacionReloj) {
                                this.editarAsignacionReloj(record._id);
                            }
                        },
                    })}
                    setValor={(valor) => this.setState({ valor })}
                    valorDefault={1}
                />
                <AgregarAsignacionReloj
                    visible={this.state.modalAgregarAsignacionReloj}
                    cerrarAgregarAsignacionReloj={this.cerrarAgregarAsignacionReloj.bind(this)}
                />
                <AgregarAsignacionesMasivas
                    visible={this.state.modalAgregarAsignacionesMasivas}
                    cerrarAgregarAsignacionesMasivas={this.cerrarAgregarAsignacionesMasivas.bind(this)}
                />
                <EditarAsignacionReloj
                    visible={this.state.modalEditarAsignacionReloj}
                    asignacionRelojId={this.state.modalEditarAsignacionRelojId}
                    cerrarEditarAsignacionReloj={this.cerrarEditarAsignacionReloj.bind(this)}
                />
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        headersToken: state.user.headersToken,
        empresaId: state.empresa.id,
        empresaNombre: state.empresa.nombre,
        permisoAgregarAsignacionReloj: state.user.tipo === 0 || state.user.permisos.find(valueTodos => valueTodos.permisoId.toString() === "69f020a37899dda241377ce5")?.activado,
        permisoEditarAsignacionReloj: state.user.tipo === 0 || state.user.permisos.find(valueTodos => valueTodos.permisoId.toString() === "69f020af7899dda241377ce6")?.activado,
        permisoDeshabilitarAsignacionReloj: state.user.tipo === 0 || state.user.permisos.find(valueTodos => valueTodos.permisoId.toString() === "69f020bd7899dda241377ce7")?.activado,
    };
};

export default connect(mapStateToProps)(AsignacionRelojes);
